import React from 'react';
import SecureLS from 'secure-ls';
import $ from 'jquery';
import { Modal, Button } from 'react-bootstrap';
import { dropByCacheKey } from 'react-router-cache-route'

const url = "https://www.school-life.co.kr/";
// const url = "http://192.168.10.27:9001";

const udfInlineLoading = () => {
  if (!$(".wrap-loading").hasClass("d-inline")) {
    $(".wrap-loading").removeClass("d-none");
    $(".wrap-loading").addClass("d-inline");
  }
}

const udfNoneLoading = () => {
  $(".wrap-loading").addClass("d-none");
  $(".wrap-loading").removeClass("d-inline");
}

// 구분 코드
var clGuNm = {
  B: '상점',
  R: '벌점',
  G: '회복',
  S: '차감'
};

// 학생 로그인시 학생 기본정보 변수
var stdtInfo = {
  HAKGWA: '',
  GRADE: '',
  BAN: '',
  BUN: '',
  STD_NM: '',
  HP_STD: '',
  HP_PRT: '',
  HP_PRT2: '',
  BBS_YN: 'N',
  RATING_GU: '',
  partKey: '',
};
const setStdtInfo = (data) => {
  stdtInfo.HAKGWA = data.HAKGWA;
  stdtInfo.GRADE = data.GRADE;
  stdtInfo.BAN = data.BAN;
  stdtInfo.BUN = data.BUN;
  stdtInfo.STD_NM = data.STD_NM;
  stdtInfo.HP_STD = data.HP_STD;
  stdtInfo.HP_PRT = data.HP_PRT;
  stdtInfo.HP_PRT2 = data.HP_PRT2;
}

// 교직원 로그인 기본정보 변수
var usrInfo = {
  HAKGWA: '',
  GRADE: '',
  BAN: '',
  BUN: '',
  HP: '',
  id: '',
  BLUE_NM: '상점',
  RED_NM: '벌점',
  GT_EDIT_YN: 'N',
  SVC_GU: 'A',
  BBS_YN: 'N',
  RATING_GU: '',
  success: false,
  partKey: '',
  MSG_GRANT: false,
  ESNTL_GU: 'T',
}

const setUsrInfo = (data) => {
  usrInfo.id = data.id;
  usrInfo.BLUE_NM = data.BLUE_NM;
  usrInfo.RED_NM = data.RED_NM;
  usrInfo.GT_EDIT_YN = data.GT_EDIT_YN;
  usrInfo.SVC_GU = data.SVC_GU;
  usrInfo.BLUE_MAX = data.BLUE_MAX;
  usrInfo.RED_MAX = data.RED_MAX;
  clGuNm.B = data.BLUE_NM;
  clGuNm.R = data.RED_NM;
  usrInfo.BBS_YN = data.BBS_YN;
  usrInfo.MSG_GRANT = data.MSG_GRANT;
  usrInfo.ESNTL_GU = data.ESNTL_GU;
  usrInfo.HAKGWA = data.HAKGWA;
  usrInfo.GRADE = data.GRADE;
  usrInfo.BAN = data.BAN;
}

// 홈으로 이동 (로그아웃 또는 로그인 세션을 읽어버린 경우)
const udfGoHome = (e) => {
  if (e.props.history !== undefined)
    e.props.history.replace('/');

  e.setState({
    alertShow: false
  });
}

// 자동 로그인
const udfAutoLogin = async (e) => {
  udfInlineLoading();
  let result = await _chkIndex();

  // console.log("login", result);
  if (!result)
    result = await _actionLogin();

  // console.log("login-action", result);

  udfNoneLoading();
  return result;
}

const _chkIndex = async () => {
  let ls = new SecureLS({
    encodingType: 'aes',
    isCompression: false,
    encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
  });

  let result = null;

  try {
    await $.ajax({
      url: url + '/uat/chkIndex.do',
      type: 'GET',
      dataType: "jsonp",
      data: {
        isMobile: 'Y',
      },
      success: function (data) {
        if (data.success === true) {
          if (data.SVC_GU !== 'A') {
            ls.setDataToLocalStorage('password', "");
          } else {
            result = data;
          }
        }

      },
      error: function (jqXHR, status, error) {
        // console.log("Request failed in common.js - _chkIndex: ", jqXHR, status, error, jqXHR.responseText);
      }
    });
  } catch (ex) {

  }

  return result;
}

const _actionLogin = async () => {
  let ls = new SecureLS({
    encodingType: 'aes',
    isCompression: false,
    encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
  });

  let result = null;

  if (ls.getDataFromLocalStorage('password') !== null && ls.getDataFromLocalStorage('password') !== "") {
    let userGu = ls.getDataFromLocalStorage('scId') === null || ls.getDataFromLocalStorage('scId') === 'undefined' ? 'STDT' : 'USR';
    // 로그인
    await $.ajax({
      url: url + '/uat/uia/actionLogin.do',
      type: 'GET',
      dataType: "jsonp",
      data: {
        id: ls.getDataFromLocalStorage('id')
        , password: ls.getDataFromLocalStorage('password')
        , userSe: userGu
        , isMobile: 'Y'
        , scId: ls.getDataFromLocalStorage('scId') === 'undefined' ? '' : ls.getDataFromLocalStorage('scId')
      },
      success: function (data) {
        if (data.success === true) {
          if (data.SVC_GU === 'A') {
            result = data;
          }
        } else {
          ls.setDataToLocalStorage('password', "");
        }
      },
      error: function (jqXHR, status, error) {
        // console.log("Request failed in common.js - actionLogin: ", jqXHR, status, error, jqXHR.responseText);
      }
    });
  }

  return result;
}

// 로그아웃
const udfLogOut = (e) => {
  e.setState({
    alertShow: true,
    alertMessage: "로그아웃을 하면 자동로그인 정보가 삭제됩니다.\n\n로그아웃하시겠습니까?",
    alertClickOk: null,
    alertClickYes: () => {
      $.ajax({
        url: url + '/uat/uia/actionLogout.do',
        type: 'GET',
        dataType: 'jsonp',
        data: { isMobile: 'Y' },
        success: function () {
          // 자동 로그인 정보 삭제
          var ls = new SecureLS({
            encodingType: 'aes',
            isCompression: false,
            encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
          });
          // ls.setDataToLocalStorage('scId', "");
          // ls.setDataToLocalStorage('id', "");
          ls.setDataToLocalStorage('password', "");

          dropByCacheKey('noticeCachce');
          dropByCacheKey('qnaCachce');
          dropByCacheKey('newsCachce');
          udfGoHome(e);
        },
        error: function (jqXHR, status, error) {
          udfGoHome(e);
          // openAlert(e, '로그아웃 도중 오류가 발생했습니다. 다시 시도해주세요.');
          // console.log('Request failed in common.js.: ', jqXHR, status, error, jqXHR.responseText);
        }
      });
    },
    alertClickNo: e.state.onClickNo === undefined ? () => { e.setState({ alertShow: false }); } : e.state.onClickNo
  });
}

/**
 * bootstrap Alert or Confirm
 */
class AlertModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        aria-labelledby="contained-modal-title-vcenter"
        animation={false}
        backdropClassName="show"
        onHide={this.props.onClickNo === null ? this.props.onClickOk : this.props.onClickNo}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="h5">{this.props.Title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "1.1rem", whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{ __html: this.props.Message }}>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-light" className={this.props.onClickNo === null ? "hidden" : "text-danger pl-3 pr-3"} onClick={this.props.onClickNo}>아니오</Button>
          <Button variant="outline-light" className={this.props.onClickYes === null ? "hidden" : "text-danger pl-5 pr-5"} onClick={this.props.onClickYes}>예</Button>
          <Button variant="outline-light" className={this.props.onClickOk === null ? "hidden" : "text-danger pl-4 pr-4"} onClick={this.props.onClickOk}>확인</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

// alert
const openAlert = (e, message, okFnc) => {
  let alertClose = () => {
    e.setState({ alertShow: false });
  }

  e.setState({
    alertShow: true,
    ruleAlertShow: false,
    alertMessage: message,
    alertClickOk: okFnc === undefined ? alertClose : okFnc,
    alertClickYes: null,
    alertClickNo: null,
  });
}

// confirm(this, message, [[yesFunction], [noFunction]])
const openConfirm = (e, message, yesFuc, noFnc) => {
  let alertClose = () => {
    e.setState({ alertShow: false });
  }

  e.setState({
    alertShow: true,
    ruleAlertShow: false,
    alertMessage: message,
    alertClickYes: yesFuc,
    alertClickNo: noFnc === undefined ? alertClose : noFnc,
    alertClickOk: yesFuc === undefined ? alertClose : null
  });
}

var BBS_YN = '';
const setBbsYn = (bbsYn) => {
  if (BBS_YN === '') BBS_YN = bbsYn;
}

export {
  clGuNm,
  url,
  udfInlineLoading,
  udfNoneLoading,
  udfAutoLogin,
  udfLogOut,
  stdtInfo,
  setStdtInfo,
  usrInfo,
  setUsrInfo,
  AlertModal,
  openAlert,
  openConfirm,
  udfGoHome,
  setBbsYn,
  BBS_YN,
}